import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import { useSchoolInfo } from '../hooks/useSchoolInfo';

export default function SignupPage() {
  const schoolInfo = useSchoolInfo();
  return (
    <div className="bg-white pb-20">
      
      {/* Header Banner following container line */}
      <section className="bg-[#eef4e6] border-b border-[#d9e5d4] py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D2923] tracking-tight font-serif-heading">
              Skriv dit barn op til Odder Lille Friskole
            </h1>
            <p className="text-base sm:text-lg text-[#5A6961] leading-relaxed">
              Vi optager løbende elever til alle klassetrin, hvor der er ledige pladser. Udfyld formularen herunder, så kontakter vi jer hurtigt for en videre dialog.
            </p>
          </div>
        </div>
      </section>

      {/* Content + Form following container line */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          
          {/* Guide Steps */}
          <div className="lg:col-span-5 space-y-6">
            <div className="space-y-6">
              <h2 className="text-xl sm:text-2xl font-bold text-[#1D2923] font-serif-heading">
                Sådan forløber opskrivningen
              </h2>

              <ol className="space-y-6 text-sm text-[#4A5850]">
                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#264A35] text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 shadow-xs">
                    1
                  </div>
                  <div>
                    <strong className="text-[#1D2923] text-base block font-bold">Udfyld formularen</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Angiv barnets navn, fødselsår og ønsket klassetrin/skoleår.</span>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#264A35] text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 shadow-xs">
                    2
                  </div>
                  <div>
                    <strong className="text-[#1D2923] text-base block font-bold">Besøg & samtale</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Vi inviterer jer til en hyggelig rundvisning og en personlig samtale med skolelederen.</span>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#264A35] text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 shadow-xs">
                    3
                  </div>
                  <div>
                    <strong className="text-[#1D2923] text-base block font-bold">Prøvedage i klassen</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">Barnet deltager i et par prøvedage for at mærke hverdagen og fællesskabet.</span>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-[#264A35] text-white flex items-center justify-center text-xs font-bold shrink-0 mt-0.5 shadow-xs">
                    4
                  </div>
                  <div>
                    <strong className="text-[#1D2923] text-base block font-bold">Endelig indmeldelse</strong>
                    <span className="text-xs sm:text-sm text-[#5A6961]">I modtager indmeldelsesblanketten og bydes officielt velkommen til skolen!</span>
                  </div>
                </li>
              </ol>

              <div className="pt-5 border-t border-[#d9e5d4] text-xs text-[#5A6961] space-y-1">
                <div>Har du akutte spørgsmål til ledige pladser?</div>
                <div>Ring direkte til os på <a href={`tel:${schoolInfo.phoneRaw}`} className="font-bold text-[#264A35] hover:underline whitespace-nowrap">{schoolInfo.phone}</a></div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-7">
            <ContactForm
              defaultSubject="Opskrivning til venteliste"
              formTitle="Opskrivningsformular"
            />
          </div>

        </div>
      </section>

    </div>
  );
}
